import { useContext } from "react";
import { TwitchChannelContext } from "../contexts/index.js";

export default function useChannelInfo() {
  return useContext(TwitchChannelContext);
}
